import initialState from './initialState';
import CRUD_ACTION_TYPES, { getNamedAction } from 'actions/CRUD_ACTION_TYPES';
import ACTION_NAMES from 'actions/ACTION_NAMES';

function userDashboardReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.USER_CONVERSION_DATA, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingConversionData: true };
        case getNamedAction(ACTION_NAMES.USER_CONVERSION_DATA, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingConversionData: false, conversion_data: action.data || [], conversionQueryParameters: action.queryParameters };
        case getNamedAction(ACTION_NAMES.USER_CONVERSION_DATA, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingConversionData: false, conversion_data: [] };

        case getNamedAction(ACTION_NAMES.USER_FUNNEL_DATA, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingFunnelData: true };
        case getNamedAction(ACTION_NAMES.USER_FUNNEL_DATA, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingFunnelData: false, funnel_data: action.data || [], funnelQueryParameters: action.queryParameters };
        case getNamedAction(ACTION_NAMES.USER_FUNNEL_DATA, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingFunnelData: false, funnel_data: [] };

        case getNamedAction(ACTION_NAMES.GET_PIPELINE_REPORT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingPipelineReport: true };
        case getNamedAction(ACTION_NAMES.GET_PIPELINE_REPORT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingPipelineReport: false, pipeline_report: action.data || []};
        case getNamedAction(ACTION_NAMES.GET_PIPELINE_REPORT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingPipelineReport: false, pipeline_report: [] };

        case getNamedAction(ACTION_NAMES.GET_CALL_HISTORY_REPORT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingCallHistoryReport: true };
        case getNamedAction(ACTION_NAMES.GET_CALL_HISTORY_REPORT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingCallHistoryReport: false, call_history_report: action.data || []};
        case getNamedAction(ACTION_NAMES.GET_CALL_HISTORY_REPORT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingCallHistoryReport: false, call_history_report: [] };

        case getNamedAction(ACTION_NAMES.GET_CALLS_REPORT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingCallsReport: true };
        case getNamedAction(ACTION_NAMES.GET_CALLS_REPORT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingCallsReport: false, calls_report: action.data || []};
        case getNamedAction(ACTION_NAMES.GET_CALLS_REPORT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingCallsReport: false, calls_report: [] };

        default:
            return state;
    }
}

export default userDashboardReducer;
